import React from 'react';
import ConditionalLinkWrapper from '../ConditionalLinkWrapper';

const NotScorableQuestionResult = ({
  tag: Tag = 'div',
  questionHref,
  parameters,
}) => {
  return (
    <Tag
      className="assessment-history-question-box-plot not-scoreable"
      title="Not Scoreable - A numeric score can't be calculated for this type of question"
    >
      <ConditionalLinkWrapper
        wrap={!!questionHref}
        href={questionHref}
        parameters={parameters}
      />
    </Tag>
  );
};

export default NotScorableQuestionResult;
